import React, { useEffect } from "react";
import HeroBanner from "../components/HeroBanner.tsx";
import SolutionSection from "../components/SolutionSection.tsx";
import ChallengeSection from "../components/ChallengeSection.tsx";
import ImpactSection from "../components/ImpactSection.tsx";
import GrowingDemandSection from "../components/GrowingDemandSection.tsx";
import CompetitorComparisonSection from "../components/CompetitorComparisonSection.tsx";
import KeyQuestionsSection from "../components/KeyQuestionsSection.tsx";
import ContactSection from "../components/ContactSection.tsx";
import { useLocation } from "react-router-dom";

const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.scrollToId) {
      const id = location.state.scrollToId;

      // Special case for scrolling to top
      if (id === "top") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        const el = document.getElementById(id);
        if (el) {
          const yOffset = id === "humanistic" ? -120 : -80;
          const y =
            el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }

      // Clear state so this only happens once
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return <React.Fragment>
    <main>
      <HeroBanner />
      <SolutionSection />
      <ChallengeSection />
      <ImpactSection />
      <GrowingDemandSection />
      <CompetitorComparisonSection />
      <KeyQuestionsSection />
    </main>
    <ContactSection />
  </React.Fragment>
};

export default Home;
